/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CounselorDutyType } from './CounselorDutyType';
import {
    CounselorDutyTypeFromJSON,
    CounselorDutyTypeFromJSONTyped,
    CounselorDutyTypeToJSON,
    CounselorDutyTypeToJSONTyped,
} from './CounselorDutyType';

/**
 * 
 * @export
 * @interface DutyScheduleBlockedPeriodResponse
 */
export interface DutyScheduleBlockedPeriodResponse {
    /**
     * 
     * @type {CounselorDutyType}
     * @memberof DutyScheduleBlockedPeriodResponse
     */
    dutyType: CounselorDutyType;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleBlockedPeriodResponse
     */
    from: Date;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleBlockedPeriodResponse
     */
    to: Date;
}



/**
 * Check if a given object implements the DutyScheduleBlockedPeriodResponse interface.
 */
export function instanceOfDutyScheduleBlockedPeriodResponse(value: object): value is DutyScheduleBlockedPeriodResponse {
    if (!('dutyType' in value) || value['dutyType'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function DutyScheduleBlockedPeriodResponseFromJSON(json: any): DutyScheduleBlockedPeriodResponse {
    return DutyScheduleBlockedPeriodResponseFromJSONTyped(json, false);
}

export function DutyScheduleBlockedPeriodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleBlockedPeriodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dutyType': CounselorDutyTypeFromJSON(json['dutyType']),
        'from': (new Date(json['from'])),
        'to': (new Date(json['to'])),
    };
}

export function DutyScheduleBlockedPeriodResponseToJSON(json: any): DutyScheduleBlockedPeriodResponse {
    return DutyScheduleBlockedPeriodResponseToJSONTyped(json, false);
}

export function DutyScheduleBlockedPeriodResponseToJSONTyped(value?: DutyScheduleBlockedPeriodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dutyType': CounselorDutyTypeToJSON(value['dutyType']),
        'from': `${value['from'].getFullYear()}-${String(value['from'].getMonth()+1).padStart(2,'0')}-${String(value['from'].getDate()).padStart(2,'0')}`,
        'to': `${value['to'].getFullYear()}-${String(value['to'].getMonth()+1).padStart(2,'0')}-${String(value['to'].getDate()).padStart(2,'0')}`,
    };
}

